import { render, staticRenderFns } from "./ShowAsideButton.vue?vue&type=template&id=48d56cb0&scoped=true&"
import script from "./ShowAsideButton.vue?vue&type=script&lang=js&"
export * from "./ShowAsideButton.vue?vue&type=script&lang=js&"
import style0 from "./ShowAsideButton.vue?vue&type=style&index=0&id=48d56cb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d56cb0",
  null
  
)

export default component.exports